import { render, staticRenderFns } from "./CreateUpdateKpiRule.vue?vue&type=template&id=0b42b162&scoped=true"
import script from "./CreateUpdateKpiRule.vue?vue&type=script&lang=js"
export * from "./CreateUpdateKpiRule.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateKpiRule.vue?vue&type=style&index=0&id=0b42b162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b42b162",
  null
  
)

export default component.exports